export function deepCopy<Input>(input: Input): Input {
  return typeof structuredClone !== "undefined"
    ? structuredClone(input)
    : JSON.parse(JSON.stringify(input));
}
